var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('span',[_vm._v(_vm._s(_vm.availability.outletName))]),_c('AtomSwitcher',{attrs:{"checked":_vm.isAvailable,"on-change":_vm.toggleAvailability}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }